import { c as _c } from "react/compiler-runtime";
import * as Tabs from '@radix-ui/react-tabs';
import { cx } from 'class-variance-authority';
import type { SegmentedControlOptionFields } from './components/segmented-control-option';
import SegmentedControlOption from './components/segmented-control-option';
export type SegmentedControlProps<T extends string = string> = {
  'aria-label': string;
  options: SegmentedControlOptionFields<T>[];
  value: T;
  onChange: (value: T) => void;
  size?: SegmentedControlSize;
  variant?: SegmentedControlVariant;
};
export type SegmentedControlSize = 'compact' | 'default';
export type SegmentedControlVariant = 'primary' | 'secondary';
const SegmentedControl = t0 => {
  const $ = _c(22);
  const {
    "aria-label": ariaLabel,
    value,
    options,
    onChange,
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const variant = t2 === undefined ? "primary" : t2;
  let t3;
  if ($[0] !== onChange) {
    t3 = val => onChange(val as T);
    $[0] = onChange;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = variant === "primary";
  const t5 = variant === "secondary";
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = cx("flex flex-row rounded-full overflow-hidden w-fit border-none p-0.5 gap-0.5", {
      "bg-canvas": t4,
      "bg-senary": t5
    });
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== options || $[6] !== size || $[7] !== value || $[8] !== variant) {
    let t8;
    if ($[10] !== size || $[11] !== value || $[12] !== variant) {
      t8 = t9 => {
        const {
          value: optionValue,
          label,
          icon
        } = t9;
        return <SegmentedControlOption size={size} value={optionValue} label={label} icon={icon} key={optionValue} selected={optionValue === value} variant={variant} />;
      };
      $[10] = size;
      $[11] = value;
      $[12] = variant;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    t7 = options.map(t8);
    $[5] = options;
    $[6] = size;
    $[7] = value;
    $[8] = variant;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[14] !== ariaLabel || $[15] !== t6 || $[16] !== t7) {
    t8 = <Tabs.List aria-label={ariaLabel} className={t6}>{t7}</Tabs.List>;
    $[14] = ariaLabel;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t3 || $[19] !== t8 || $[20] !== value) {
    t9 = <Tabs.Root value={value} onValueChange={t3} activationMode="manual">{t8}</Tabs.Root>;
    $[18] = t3;
    $[19] = t8;
    $[20] = value;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
export default SegmentedControl;